/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Credit } from '../../../assets/icons/credit-card.svg'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

const WithBorder = `
  padding: 0;
  padding: 0 15px;
`

const OutrosCartoes = styled.div`
  color: ${( { tema } ) => tema}
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
  display: flex;
  align-items: center;
  ${( { border } ) => border && WithBorder};
  span {
    flex: 9;
  }
  svg {
    flex: 1;
  }
  svg path {
      stroke: ${( { tema } ) => tema}
    }

  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    padding-bottom: 15px;
    line-height: 19px;
    svg {
      padding-right: 10px;
    }
  }
`

const LabelVerCartoesCadastrados = ( { setActiveModal, tema = '#009BBF', border = false } ) => {
  return (
    <OutrosCartoes
      border={ border }
      className="outros-cartoes"
      onClick={ () => setActiveModal( true ) }
      tema={ tema }
    >
      <Credit />

      <span style={{ 'cursor': 'pointer', 'lineHeight': '20px' }}>Ver outros cartões de crédito cadastrados</span>
    </OutrosCartoes>
  )
}

export default LabelVerCartoesCadastrados
